module.exports = __webpack_public_path__ + "static/media/man-woman-full-2.da97d6b2.png";